mutation ExtendColumnRange($id: ID!, $edge: String!) {
  extendColumnRange(id: $id, edge: $edge) {
    ok
    errors
    firstSefariaId
    lastSefariaId
    skipPrefixWords
    cutTrailingWords
  }
}
